import {
    apiRequest,
    mertuaDetail
} from "../../../../../../services/adapters/kepegawaian/mertuaService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", mertuaDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository